import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BankVerificationService {

  public isBankVerificationServiceAvailable = new EventEmitter<boolean>();
}
